import React, { useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MenuCard from './MenuCard';
import CarauselComp from 'atoms/Carausel/Presentation/CarauselComp';
import {
  fetchItemDetailsAction,
  addItemToFavouriteAction,
  addItemToUnFavouriteAction,
} from '@kfc-global/react-shared/redux/Actions/MenuAction';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import FoodItemListHandlers from 'organisms/CartPage/AU/Presentation/ReusableComponents/FoodItemListHandlers';
import { UserOrderContext } from 'context/context';
import UserLocalization from './UserLocalization';
import {
  addItemToCartAction,
  showCustomizationModalAction,
  setUserLastActiveTime,
  updateItemQuantityAction,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import {
  jsontoObjects,
  getValueOrDefaultObject,
  ParseJsonSafely,
  triggerCartModel,
  createPayloadForStatusCall,
  getPDPurl,
  getBackgroundImagePath,
  isCateringDisposition,
  getTernaryValue,
  checkByParams,
  getAndCheckIfOneTrue,
} from 'common/utilities/utils';
import {
  checkCategoryAvailability,
  getDynamicMenuAlertType,
} from 'molecules/DynamicMenuAlert/AU/Utils/DynamicMenuAlertUtils';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import {
  CAROUSEL_RESPONSIVE_SETTINGS,
  LOCAL_STORAGE_KEYS,
  CURRENTSTOREINFO,
  CART_SELECT_STORE_MSG,
  DYNAMIC_MENU_CONSTANTS,
} from 'common/constants/SharedConstants';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { getBulkStoreStatus, getStoreStatusForTimeSaga } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import AlertContainer from 'organisms/AlertComponent/Container/AU/AlertContainer';
import AlertFormInsideModel from 'molecules/Alert';
import AlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

const caroselDefaults = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  adaptiveHeight: false,
  autoplay: false,
  variableWidth: true,
  responsive: CAROUSEL_RESPONSIVE_SETTINGS,
};

const renderProducts = (productsArray, cardRenderer) => {
  return (
    !!productsArray.length &&
    productsArray.map(elm => {
      return cardRenderer(elm);
    })
  );
};

const getMenuItemData = (id, product, itemFoodlineId) => {
  return {
    foodName: product?.productName[0]?.value,
    foodItemId: id,
    cartPrice: product?.productPrice,
    modifiers: [],
    quantity: 1,
    foodLineId: itemFoodlineId,
  };
};

const getCategoryId = (categoryId, item) => {
  return categoryId !== '' ? categoryId : item.category_id;
};

const getFinalPayloadData = ({ isForNow, futureDateTime, payload }) => {
  return !isForNow ? { ...payload, futureDateTimeInEpochFormat: futureDateTime } : payload;
};

export const getStoreStatusData = (params) => {
  const { e, userParams, dispatch, finalPayload, tenantData, productId, customizable, catId, productInfo, currentStoreInfo, serviceType, shouldCheckDropOffAddress, onCardClickHandler } = params;
  userParams.localized ? dispatch(
    getStoreStatusForTimeSaga({ data: finalPayload, tenantId: tenantData?.tenantId }, (storeDetails) =>
      onCardClickHandler({e, productId, customizable, catId, productInfo, storesWithStatus: storeDetails}),
    ),
  ) :
    dispatch(
      getBulkStoreStatus(
        { data: createPayloadForStatusCall([currentStoreInfo], serviceType, null, shouldCheckDropOffAddress), tenantId: tenantData?.tenantId },
        (storeDetails) => onCardClickHandler({e, productId, customizable, catId, productInfo, storesWithStatus: storeDetails})
      ));
}

const MenuItemList = props => {
  const {
    productList = [],
    cardType = '',
    tenantData = {},
    categoryId,
    catalogs,
    storeClosedData,
    setShowTopScrollBtn,
  } = props;
  const { VIEW_MENU, STORE_TEXT, STORE_CLOSED_TEXT, CHANGE, CATERING_STORE_CLOSED_MSG } = TRANSLATE_MAPPING_KEY;
  const dispositionNew = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW));

  const { QUANTITY_ACTION } = CART_PAGE_CONSTANTS;
  const {
    ADD_TO_CART_CLICK,
    PLP_PDP_DETAILS,
    MINI_PDP_DATA,
    FROMFLAGPLP,
    CLOSED,
    NOT_WITHIN_OPERATING_HOURS,
    STORE_NOT_ALIVE,
    SCHEDULE_ORDER_DATA,
    DOORDASH_NOT_SERVICEABLE,
  } = START_ORDER_CONSTANTS;
  const { PlpProductCard = {}, web = {} } = props.tenantData?.componentOptions || {};
  const { shouldCheckDropOffAddress = false } = web;
  const { RESET_MODGROUP_IDS_UPDATE } = MENU_PDP_PAGE_CONSTANTS;
  const { plpWarningMsg = false } = PlpProductCard;
  const [caroselCount, setCaroselCount] = useState(1);
  const dispatch = useDispatch();
  const cartReducer = useSelector(data => data.cartReducer);
  const menuReducerData = useSelector(data => data.menuReducer?.data || {});
  const { categories = [] } = menuReducerData || {};
  const { cartData = {} } = getValueOrDefaultObject(cartReducer);
  const isForNow = cartData?.requestedDateTime?.isForNow;
  const futureDateTime = cartData?.requestedDateTime?.futureDateTime;
  const userParams = useSelector(data => data.appStateReducer?.userStatus);
  const [selectedCat, setSelectedCat] = useState(props.selectedCat);
  const [localizationFlow, setLocalizationFlow] = useState(false);
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const storesWithStatusData = useSelector(data => data.storesReducer?.storesWithStatus);
  const [showAlert, setShowAlert] = useState(false);
  const [storeClosedMsg, setStoreClosedMsg] = useState(null);

  const [activeId, setActiveId] = useState(null);
  const { headerData: { plpBackgroundImage = {} } = {} } = useSelector(state =>
    getValueOrDefaultObject(state?.marketConfigReducer?.response),
  );
  const plpbackgroundImageData = getBackgroundImagePath(plpBackgroundImage);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setLocalizationFlow(false);
  });

  //Analytic AddToCart for non-customizable product KRM-14026
  const { addToCartAnalyticsOnly } = FoodItemListHandlers(
    { cartId: cartData?.id },
    tenantData?.tenantId,
    undefined,
    undefined,
    categories,
    undefined,
    dispatch,
    undefined,
  );

  //modify this before finalization
  // duplicate exists in organisms/CartPage/Presentation/ReusableComponents/RecomendationItem.js
  const clickHandler = (e, id, customizable, catId, itemCount, product, itemFoodlineId) => {
    e?.stopPropagation();
    setActiveId(id);
    if (userParams.localized) {
      if (customizable) {
        setSelectedCat(catId);
        userOrderStateDispatch({
          type: MINI_PDP_DATA,
          value: { id: id, flag: FROMFLAGPLP, foodLineId: '' },
        });
        //Customization Modal
        userOrderStateDispatch({ type: RESET_MODGROUP_IDS_UPDATE });
        dispatch(
          fetchItemDetailsAction({
            tenantId: tenantData.tenantId,
            catalogName: catalogs,
            itemId: id,
          }),
        );
      } else if (itemCount === 0) {
        dispatch(
          addItemToCartAction(
            {
              params: {
                basketId: cartReducer?.cartData?.id,
              },
              tenantId: tenantData.tenantId,
            },
            [{ Id: id, categoryId: categoryId, quantity: itemCount + 1, modGrps: [] }],
          ),
        );
        dispatch(setUserLastActiveTime(new Date()));
        //Analytic event for non-customizable items
        addToCartAnalyticsOnly(getMenuItemData(id, product, itemFoodlineId), QUANTITY_ACTION.Increase);
      } else if (itemCount > 0) {
        dispatch(
          updateItemQuantityAction(
            {
              params: {
                basketId: cartReducer?.cartData?.id,
                basketLineItemId: itemFoodlineId,
              },
              tenantId: tenantData.tenantId,
            },
            {
              quantity: itemCount + 1,
            },
          ),
        );
        dispatch(setUserLastActiveTime(new Date()));
        //Analytic event for non-customizable items
        addToCartAnalyticsOnly(getMenuItemData(id, product, itemFoodlineId), QUANTITY_ACTION.Increase);
      }
    } else {
      setLocalizationFlow(true);
      userOrderStateDispatch({
        type: ADD_TO_CART_CLICK,
        value: {
          addToCart: true,
          productItemId: id,
          categoryId: categoryId,
          oldProduct: product,
          customizable: customizable,
          catalogs: catalogs,
          fromPdpPage: false,
        },
      });
    }
  };
  const currentItemDetails = useSelector(({ menuReducer }) => menuReducer?.currentItemDetails);
  useEffect(() => {
    if (currentItemDetails && selectedCat && userOrderState.minipdpData.itemId === currentItemDetails.id) {
      //to set flag in cartReducer
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: true,
          categorySelected: selectedCat,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentItemDetails]);

  const settings = {
    ...caroselDefaults,
    beforeChange: (current, next) => {
      setCaroselCount(Math.round(next + 1));
    },
    variableWidth: false,
  };
  const currentStoreInfo = ParseJsonSafely(localStorage.getItem(CURRENTSTOREINFO));
  const serviceType = localStorage.getItem(LOCAL_STORAGE_KEYS.SERVICE_TYPE);
  const checkStoreStatus = (e, productId, customizable, catId, productInfo) => {
    if (plpWarningMsg) {
      const dataList = createPayloadForStatusCall([currentStoreInfo], serviceType, null, shouldCheckDropOffAddress);
      const payload = {
        storeid: dataList[0]?.storeId,
        service: dataList[0]?.service,
        channel: dataList[0]?.channel,
      };
      const finalPayload = getFinalPayloadData({ isForNow, futureDateTime, payload });
      getStoreStatusData({e, userParams, dispatch, finalPayload, tenantData, productId, customizable, catId, productInfo, currentStoreInfo, serviceType, shouldCheckDropOffAddress, onCardClickHandler});
    } else {
      onCardClickHandler({e, productId, customizable, catId, productInfo, storesWithStatus: storesWithStatusData});
    }
  };

  const onCardClickHandler = ({e, productId, customizable, category_id, productInfo,storesWithStatus}) => {
    e.preventDefault();
    e.stopPropagation();
    const itemExpried =
      userOrderState?.timeBasedCetegory?.isTimeExpired &&
      checkCategoryAvailability(
        {
          categoryUrl: productInfo?.categoryURL[0],
          itemInCart: userOrderState?.timeBasedCetegory?.timebasedItemInCart,
          alertType: getDynamicMenuAlertType(
            userOrderState?.timeBasedCetegory?.timebasedItemInCart,
            DYNAMIC_MENU_CONSTANTS?.ITEM,
          ),
        },
        userOrderState?.timeBasedCetegory,
        userOrderStateDispatch,
      );
    if (itemExpried) {
      return;
    }
    if (plpWarningMsg) {
      const store = storesWithStatus.find(storeDetails =>
        getAndCheckIfOneTrue(storeDetails?.storeId === currentStoreInfo?.id, storeDetails?.id === currentStoreInfo?.id),
      );
      const { summary = {} } = getValueOrDefaultObject(store);
      const { status = {} } = getValueOrDefaultObject(summary);
      const { currentStatus = '', message = '' } = getValueOrDefaultObject(status);
      if (currentStatus === CLOSED) {
        setShowAlert(true);
        setStoreClosedMsg(
          getTernaryValue(
            checkByParams(
              message !== NOT_WITHIN_OPERATING_HOURS,
              message !== STORE_NOT_ALIVE,
              getTernaryValue(message.includes(DOORDASH_NOT_SERVICEABLE), DOORDASH_NOT_SERVICEABLE, '') !==
              DOORDASH_NOT_SERVICEABLE,
            ),
            message,
            null,
          ),
        );
        return;
      }
    }

    let ProductDetails = {
      productId,
      customizable,
      category_id,
      catalogName: catalogs,
      productInfo: productInfo,
      isFromPlp: true,
    };
    userOrderStateDispatch({
      type: PLP_PDP_DETAILS,
      value: ProductDetails,
    });
    localStorage.setItem('ProductDetails', JSON.stringify(ProductDetails));
    props.history.push({
      pathname: getPDPurl(productInfo.categoryURL, productInfo.prodURL, props.history?.location?.pathname),
    });
  };

  const addItemToFavourite = (tenantId, data, customerId) => {
    dispatch(
      addItemToFavouriteAction(
        {
          tenantId,
          customerId,
        },
        data,
      ),
    );
  };

  const removeItemFromFavourite = (tenantId, customerId, itemId) => {
    dispatch(
      addItemToUnFavouriteAction({
        tenantId,
        customerId,
        itemId,
      }),
    );
  };

  const cardRenderer = (elm = {}) => {
    const {
      items: [item],
      dname: dName,
      url,
      content,
    } = elm;
    const additionalProperties = jsontoObjects(item.additionalProperties);
    let category_id = getCategoryId(categoryId, elm);
    return (
      <MenuCard
        item={item}
        key={item.id}
        activeId={activeId}
        cardId={item.id}
        cardType={cardType}
        configureOptions={PlpProductCard}
        tenantData={tenantData}
        servingCount={additionalProperties.servings}
        button={elm.button}
        categoryId={category_id}
        clickHandler={clickHandler}
        customizable={item.customizable}
        onCardClickHandler={checkStoreStatus}
        userParams={userParams}
        storeClosedData={storeClosedData}
        addFavourite={addItemToFavourite}
        removeFavourite={removeItemFromFavourite}
        setShowTopScrollBtn={setShowTopScrollBtn}
        data-testid='menu-card-component'
        dName={dName}
        prodURL={url}
        productContent={content}
        plpbackgroundImageData={plpbackgroundImageData}
        {...additionalProperties}
        {...item}
      />
    );
  };

  const onClickBtnHandler = () => {
    setShowAlert(false);
    triggerCartModel(userOrderStateDispatch, localStorage.getItem(LOCAL_STORAGE_KEYS.RETAIN_ADDRESS));
  };

  const cateringStoreClosedModel = getTernaryValue(
    showAlert,
    <AlertFormInsideModel
      handleClose={() => setShowAlert(false)}
      classNames='plp-warning-msg plp-page-model'
      CartAlertForm={
        <AlertForm
          title={`${translateWithI18Next(STORE_CLOSED_TEXT)}`}
          contentMsg={`${translateWithI18Next(CATERING_STORE_CLOSED_MSG)}`}
          imageSrc={IMAGE_PATH.LocationWithoutError}
          confirmButtonText={`${translateWithI18Next(CHANGE)} ${translateWithI18Next(STORE_TEXT)}`}
          confirmHandler={() => {
            userOrderStateDispatch({
              type: SCHEDULE_ORDER_DATA,
              value: {
                showScheduleOrderCatering: true,
                selectedStoreInfo: localStorage.getItem(LOCAL_STORAGE_KEYS.STORE_INFO),
                changeFlow: true,
              },
            });
            setShowAlert(false);
          }}
          cancelHandler={() => setShowAlert(false)}
          cancelButtonText={translateWithI18Next(VIEW_MENU)}
        />
      }
    />,
    null,
  );

  const storeCloseModel = (
    <AlertContainer
      handleClose={() => setShowAlert(false)}
      showAlert={showAlert}
      onClickBtnHandler={onClickBtnHandler}
      stoerName={storeClosedData?.storeName}
      storeClosedMsg={storeClosedMsg}
      contentMsg={CART_SELECT_STORE_MSG}
    />
  );

  return (
    <>
      <div className='product-container'>
        {localizationFlow && <UserLocalization />}
        {cardType === 'carousal' ? (
          <>
            <div className='individual-card-counter'>
              {caroselCount}/{productList.length}
            </div>
            <CarauselComp settings={settings}>{renderProducts(productList, cardRenderer)}</CarauselComp>
          </>
        ) : (
          renderProducts(productList, cardRenderer)
        )}
      </div>
      {getTernaryValue(isCateringDisposition(dispositionNew?.type), cateringStoreClosedModel, storeCloseModel)}
    </>
  );
};

export default withRouter(MenuItemList);
